import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import {Observable} from 'rxjs/Observable';
import { ConfigAngular } from './model/configAngular';

/*
  Servicio que se encarga de tener disponible la configuración del archivo de
  configuración globar del proyecto: nos sirve para poder tener distintas configuraciones
  para desarrollo, producción, etc.
  También nos puede servir para tener contantes disponible para todo el proyecto.
*/
class EnvData {
   env: string;
}

@Injectable()
export class AppConfigService {

    private config: ConfigAngular;
    private env:    Object = null;


    constructor(private http: Http) {
    }



    /**
     * Use to get the data found in the first file (env file)
     */
    public getEnv(key: any) {
        return this.env[key];
    }


    public getFirebase()
    {
      return this.config.firebase;
    }

    public getUsuariosUrl(){
      return this.config.usuariosUrl;
    }

    public getUsersUrl(){
      return this.config.usersUrl;
    }

    /**
       * This method:
       *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
       *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
       */
      public load() {

            return new Promise((resolve) => {
              this.http.get('assets/env.json').map( res => res.json() ).catch((error: any):any => {
                  console.log('Configuration file "env.json" could not be read');
                  resolve(true);
                  return Observable.throw(error.json().error || 'Server error');
              }).subscribe( (envResponse: EnvData) => {
                  this.env = envResponse;
                  //let request:any = null;
                  //console.log("App.config: load: " + envResponse);
                  var fichero: string = "assets/";
                  fichero += 'config.' + envResponse.env + '.json';

                  this.http.get(fichero)
                         .map((res:Response) => {
                              //console.log("AppConfig: load: " + res.text());
                              this.config = JSON.parse(res.text());
                              //console.log("App Config: " + this.config.firebase.apiKey)

                            })
                            .subscribe(() => {
                                //this.config = responseData;
                                //console.log(responseData);
                                resolve(true);
                            });
              });
          });
      }




}



// WEBPACK FOOTER //
// ./src/app/app.config.ts